<div class="content-wrapper-parent">
  <div class="content-wrapper">
    <div class="registration-container">
      <!-- Loading Overlay -->
      <div class="loading-overlay" *ngIf="isLoading">
        <div class="loading-content">
          <mat-spinner diameter="60" color="primary"></mat-spinner>
          <p class="loading-text">Processing...</p>
        </div>
      </div>

      <!-- Registration Panel -->
      <div class="registration-panel">
        <div class="registration-panel-content">
          <!-- Progress Indicator -->
          <div class="progress-indicator">
            <div class="progress-steps">
              <div class="progress-step" [class.active]="currentStep >= 1" [class.completed]="currentStep > 1">
                <div class="step-number">1</div>
                <div class="step-label">Email</div>
              </div>
              <div class="progress-line" [class.completed]="currentStep > 1"></div>
              <div class="progress-step" [class.active]="currentStep >= 2" [class.completed]="currentStep > 2">
                <div class="step-number">2</div>
                <div class="step-label">Verify</div>
              </div>
              <div class="progress-line" [class.completed]="currentStep > 2"></div>
              <div class="progress-step" [class.active]="currentStep >= 3" [class.completed]="currentStep > 3">
                <div class="step-number">3</div>
                <div class="step-label">Password</div>
              </div>
              <div class="progress-line" [class.completed]="currentStep > 3"></div>
              <div class="progress-step" [class.active]="currentStep >= 4" [class.completed]="currentStep > 4">
                <div class="step-number">4</div>
                <div class="step-label">Profile</div>
              </div>
              <div class="progress-line" [class.completed]="currentStep > 4"></div>
              <div class="progress-step" [class.active]="currentStep >= 5" [class.completed]="currentStep > 5">
                <div class="step-number">5</div>
                <div class="step-label">Company</div>
              </div>
              <div class="progress-line" [class.completed]="currentStep > 5"></div>
              <div class="progress-step" [class.active]="currentStep >= 6" [class.completed]="currentStep > 6">
                <div class="step-number">6</div>
                <div class="step-label">Plan</div>
              </div>
              <div class="progress-line" [class.completed]="currentStep > 6"></div>
              <div class="progress-step" [class.active]="currentStep >= 7">
                <div class="step-number">7</div>
                <div class="step-label">Done</div>
              </div>
            </div>
          </div>

          <!-- Step Header -->
          <div class="step-header">
            <h1 *ngIf="currentStep === 1">Create Your Account</h1>
            <h1 *ngIf="currentStep === 2">Verify Your Email</h1>
            <h1 *ngIf="currentStep === 3">Set Your Password</h1>
            <h1 *ngIf="currentStep === 4">Tell Us About Yourself</h1>
            <h1 *ngIf="currentStep === 5">Company Information</h1>
            <h1 *ngIf="currentStep === 6">Choose Your Plan</h1>
            <h1 *ngIf="currentStep === 7">Welcome Aboard!</h1>
          </div>

          <!-- Error Message -->
          <div class="error-banner" *ngIf="errorMessage">
            <mat-icon svgIcon="error"></mat-icon>
            <span>{{ errorMessage }}</span>
          </div>

          <!-- STEP 1: EMAIL ENTRY -->
          <form *ngIf="currentStep === 1" [formGroup]="emailForm" (ngSubmit)="goToVerification()" class="step-form">
            <p class="step-description">Enter your email address to get started</p>
            
            <div class="form-field">
              <label for="email">Email Address</label>
              <mat-form-field appearance="outline" class="form-field-standard">
                <input matInput 
                       id="email"
                       formControlName="email" 
                       type="email"
                       placeholder="you@company.com"
                       autocomplete="email">
              </mat-form-field>
              <div class="error-message" *ngIf="emailForm.get('email')?.invalid && emailForm.get('email')?.touched">
                <span *ngIf="emailForm.get('email')?.errors?.['required']">Email is required</span>
                <span *ngIf="emailForm.get('email')?.errors?.['email']">Please enter a valid email address</span>
                <span *ngIf="emailForm.get('email')?.errors?.['emailTypo']">
                  Did you mean {{ emailForm.get('email')?.errors?.['emailTypo'].suggestion }}?
                </span>
              </div>
            </div>

            <button type="submit" 
                    mat-raised-button 
                    color="primary" 
                    class="continue-button"
                    [disabled]="!emailForm.valid || isLoading">
              Continue
            </button>
          </form>

          <!-- STEP 2: EMAIL VERIFICATION -->
          <form *ngIf="currentStep === 2" [formGroup]="verificationForm" (ngSubmit)="verifyCode()" class="step-form">
            <div class="flex justify-center" style="margin-bottom: 24px;">
              <div style="width: 64px; height: 64px; border-radius: 50%; background: linear-gradient(135deg, var(--ps-digital-blue) 0%, var(--primary-dark) 100%); display: flex; align-items: center; justify-content: center; box-shadow: 0 4px 12px rgba(0, 112, 210, 0.2);">
                <mat-icon svgIcon="mail" style="color: white; font-size: 32px !important; height: 32px !important; width: 32px !important;"></mat-icon>
              </div>
            </div>
            
            <p class="step-description">
              We've sent a 6-digit code to <strong>{{ emailForm.get('email')?.value }}</strong>
            </p>

            <div class="form-field">
              <label for="verification-code">Verification Code</label>
              <mat-form-field appearance="outline" class="form-field-standard">
                <input matInput 
                       id="verification-code"
                       formControlName="code" 
                       type="text"
                       placeholder="000000"
                       maxlength="6"
                       autocomplete="one-time-code">
              </mat-form-field>
              <div class="error-message" *ngIf="verificationForm.get('code')?.invalid && verificationForm.get('code')?.touched">
                <span *ngIf="verificationForm.get('code')?.errors?.['required']">Verification code is required</span>
                <span *ngIf="verificationForm.get('code')?.errors?.['pattern']">Code must be 6 digits</span>
              </div>
            </div>

            <div class="resend-container">
              <button type="button" 
                      mat-button 
                      (click)="resendCode()"
                      [disabled]="codeResendCooldown > 0 || isLoading">
                <mat-icon svgIcon="refresh"></mat-icon>
                <span *ngIf="codeResendCooldown === 0">Resend Code</span>
                <span *ngIf="codeResendCooldown > 0">Resend in {{ codeResendCooldown }}s</span>
              </button>
            </div>

            <button type="submit" 
                    mat-raised-button 
                    color="primary" 
                    class="continue-button"
                    [disabled]="!verificationForm.valid || isLoading">
              Verify
            </button>

            <button type="button" 
                    mat-stroked-button 
                    class="back-button"
                    (click)="goBack()"
                    [disabled]="isLoading">
              <mat-icon svgIcon="arrow_back"></mat-icon>
              Back
            </button>
          </form>

          <!-- STEP 3: PASSWORD -->
          <form *ngIf="currentStep === 3" [formGroup]="passwordForm" (ngSubmit)="registerUser()" class="step-form">
            <p class="step-description">Create a strong password to protect your account</p>

            <div class="form-field">
              <label for="password">Password</label>
              <mat-form-field appearance="outline" class="form-field-standard">
                <input matInput 
                       id="password"
                       formControlName="password" 
                       [type]="hidePassword ? 'password' : 'text'"
                       placeholder="Enter your password"
                       autocomplete="new-password">
                <button mat-icon-button matSuffix type="button" (click)="hidePassword = !hidePassword">
                  <mat-icon [svgIcon]="hidePassword ? 'visibility' : 'visibility_off'"></mat-icon>
                </button>
              </mat-form-field>
              <div class="error-message" *ngIf="passwordForm.get('password')?.invalid && passwordForm.get('password')?.touched">
                <span *ngIf="passwordForm.get('password')?.errors?.['required']">Password is required</span>
                <span *ngIf="passwordForm.get('password')?.errors?.['passwordComplexity']">
                  Password must be at least 8 characters with letters and numbers
                </span>
              </div>
              
              <!-- Password Strength Indicator -->
              <div class="password-strength" *ngIf="passwordForm.get('password')?.value">
                <div class="strength-bar-container">
                  <div class="strength-bar" 
                       [style.width.%]="passwordStrength"
                       [class.weak]="passwordStrength < 40"
                       [class.medium]="passwordStrength >= 40 && passwordStrength < 70"
                       [class.strong]="passwordStrength >= 70"></div>
                </div>
                <div class="strength-label">
                  <span *ngIf="passwordStrength < 40" class="weak">Weak</span>
                  <span *ngIf="passwordStrength >= 40 && passwordStrength < 70" class="medium">Medium</span>
                  <span *ngIf="passwordStrength >= 70" class="strong">Strong</span>
                </div>
              </div>
            </div>

            <div class="form-field">
              <label for="confirm-password">Confirm Password</label>
              <mat-form-field appearance="outline" class="form-field-standard">
                <input matInput 
                       id="confirm-password"
                       formControlName="confirmPassword" 
                       [type]="hidePasswordConfirm ? 'password' : 'text'"
                       placeholder="Re-enter your password"
                       autocomplete="new-password">
                <button mat-icon-button matSuffix type="button" (click)="hidePasswordConfirm = !hidePasswordConfirm">
                  <mat-icon [svgIcon]="hidePasswordConfirm ? 'visibility' : 'visibility_off'"></mat-icon>
                </button>
              </mat-form-field>
              <div class="error-message" *ngIf="passwordForm.get('confirmPassword')?.invalid && passwordForm.get('confirmPassword')?.touched">
                <span *ngIf="passwordForm.get('confirmPassword')?.errors?.['required']">Please confirm your password</span>
              </div>
              <div class="error-message" *ngIf="passwordForm.errors?.['passwordMismatch'] && passwordForm.get('confirmPassword')?.touched">
                <span>Passwords do not match</span>
              </div>
            </div>

            <button type="submit" 
                    mat-raised-button 
                    color="primary" 
                    class="continue-button"
                    [disabled]="!passwordForm.valid || isLoading">
              Create Account
            </button>

            <button type="button" 
                    mat-stroked-button 
                    class="back-button"
                    (click)="goBack()"
                    [disabled]="isLoading">
              <mat-icon svgIcon="arrow_back"></mat-icon>
              Back
            </button>
          </form>

          <!-- STEP 4: USER INFO -->
          <form *ngIf="currentStep === 4" [formGroup]="userInfoForm" (ngSubmit)="submitUserInfo()" class="step-form">
            <p class="step-description">Let's personalize your experience</p>

            <div class="form-row">
              <div class="form-field">
                <label for="first-name">First Name</label>
                <mat-form-field appearance="outline" class="form-field-standard">
                  <input matInput 
                         id="first-name"
                         formControlName="firstName" 
                         placeholder="John"
                         autocomplete="given-name">
                </mat-form-field>
                <div class="error-message" *ngIf="userInfoForm.get('firstName')?.invalid && userInfoForm.get('firstName')?.touched">
                  <span *ngIf="userInfoForm.get('firstName')?.errors?.['required']">First name is required</span>
                </div>
              </div>

              <div class="form-field">
                <label for="last-name">Last Name</label>
                <mat-form-field appearance="outline" class="form-field-standard">
                  <input matInput 
                         id="last-name"
                         formControlName="lastName" 
                         placeholder="Smith"
                         autocomplete="family-name">
                </mat-form-field>
                <div class="error-message" *ngIf="userInfoForm.get('lastName')?.invalid && userInfoForm.get('lastName')?.touched">
                  <span *ngIf="userInfoForm.get('lastName')?.errors?.['required']">Last name is required</span>
                </div>
              </div>
            </div>

            <button type="submit" 
                    mat-raised-button 
                    color="primary" 
                    class="continue-button"
                    [disabled]="!userInfoForm.valid || isLoading">
              Continue
            </button>

            <button type="button" 
                    mat-stroked-button 
                    class="back-button"
                    (click)="goBack()"
                    [disabled]="isLoading">
              <mat-icon svgIcon="arrow_back"></mat-icon>
              Back
            </button>
          </form>

          <!-- STEP 5: COMPANY INFO -->
          <form *ngIf="currentStep === 5" [formGroup]="companyForm" (ngSubmit)="submitCompany()" class="step-form">
            <p class="step-description">Tell us about your organization</p>

            <div class="form-field">
              <label for="region">Region</label>
              <mat-form-field appearance="outline" class="form-field-standard">
                <mat-select id="region" formControlName="regionCode" placeholder="Select region">
                  <mat-option *ngFor="let region of regions" [value]="region.code">
                    {{ region.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <div class="error-message" *ngIf="companyForm.get('regionCode')?.invalid && companyForm.get('regionCode')?.touched">
                <span *ngIf="companyForm.get('regionCode')?.errors?.['required']">Region is required</span>
              </div>
            </div>

            <div class="form-field">
              <label for="company-name">Company Name</label>
              <mat-form-field appearance="outline" class="form-field-standard">
                <input matInput 
                       id="company-name"
                       formControlName="companyName" 
                       placeholder="Your company name"
                       autocomplete="organization">
              </mat-form-field>
              <div class="error-message" *ngIf="companyForm.get('companyName')?.invalid && companyForm.get('companyName')?.touched">
                <span *ngIf="companyForm.get('companyName')?.errors?.['required']">Company name is required</span>
              </div>
            </div>

            <div class="form-field">
              <label for="industry">Industry</label>
              <mat-form-field appearance="outline" class="form-field-standard">
                <mat-select id="industry" formControlName="industryCode" placeholder="Select industry">
                  <mat-option *ngFor="let industry of industries" [value]="industry.industryId">
                    {{ industry.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <div class="error-message" *ngIf="companyForm.get('industryCode')?.invalid && companyForm.get('industryCode')?.touched">
                <span *ngIf="companyForm.get('industryCode')?.errors?.['required']">Industry is required</span>
              </div>
            </div>

            <div class="form-field">
              <label for="country">Country</label>
              <mat-form-field appearance="outline" class="form-field-standard">
                <mat-select id="country" formControlName="countryCode" placeholder="Select country">
                  <mat-option *ngFor="let country of countries" [value]="country.countryCode">
                    {{ country.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <div class="error-message" *ngIf="companyForm.get('countryCode')?.invalid && companyForm.get('countryCode')?.touched">
                <span *ngIf="companyForm.get('countryCode')?.errors?.['required']">Country is required</span>
              </div>
            </div>

            <div class="form-row">
              <div class="form-field">
                <label for="contact-name">Contact Name</label>
                <mat-form-field appearance="outline" class="form-field-standard">
                  <input matInput 
                         id="contact-name"
                         formControlName="contactName" 
                         placeholder="Contact person"
                         autocomplete="name">
                </mat-form-field>
                <div class="error-message" *ngIf="companyForm.get('contactName')?.invalid && companyForm.get('contactName')?.touched">
                  <span *ngIf="companyForm.get('contactName')?.errors?.['required']">Contact name is required</span>
                </div>
              </div>

              <div class="form-field">
                <label for="contact-email">Contact Email</label>
                <mat-form-field appearance="outline" class="form-field-standard">
                  <input matInput 
                         id="contact-email"
                         formControlName="contactEmail" 
                         type="email"
                         placeholder="contact@company.com"
                         autocomplete="email">
                </mat-form-field>
                <div class="error-message" *ngIf="companyForm.get('contactEmail')?.invalid && companyForm.get('contactEmail')?.touched">
                  <span *ngIf="companyForm.get('contactEmail')?.errors?.['required']">Contact email is required</span>
                  <span *ngIf="companyForm.get('contactEmail')?.errors?.['email']">Please enter a valid email</span>
                </div>
              </div>
            </div>

            <!-- Optional Address Details -->
            <details class="address-details">
              <summary>Add Address (Optional)</summary>
              <div class="address-fields">
                <div class="form-field">
                  <label for="address1">Address Line 1</label>
                  <mat-form-field appearance="outline" class="form-field-standard">
                    <input matInput 
                           id="address1"
                           formControlName="address1" 
                           placeholder="Street address"
                           autocomplete="address-line1">
                  </mat-form-field>
                </div>

                <div class="form-field">
                  <label for="address2">Address Line 2</label>
                  <mat-form-field appearance="outline" class="form-field-standard">
                    <input matInput 
                           id="address2"
                           formControlName="address2" 
                           placeholder="Apartment, suite, etc."
                           autocomplete="address-line2">
                  </mat-form-field>
                </div>

                <div class="form-row">
                  <div class="form-field">
                    <label for="city">City</label>
                    <mat-form-field appearance="outline" class="form-field-standard">
                      <input matInput 
                             id="city"
                             formControlName="city" 
                             placeholder="City"
                             autocomplete="address-level2">
                    </mat-form-field>
                  </div>

                  <div class="form-field">
                    <label for="postcode">Postcode</label>
                    <mat-form-field appearance="outline" class="form-field-standard">
                      <input matInput 
                             id="postcode"
                             formControlName="postcode" 
                             placeholder="Postal code"
                             autocomplete="postal-code">
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </details>

            <button type="submit" 
                    mat-raised-button 
                    color="primary" 
                    class="continue-button"
                    [disabled]="!companyForm.valid || isLoading">
              Continue
            </button>

            <button type="button" 
                    mat-stroked-button 
                    class="back-button"
                    (click)="goBack()"
                    [disabled]="isLoading">
              <mat-icon svgIcon="arrow_back"></mat-icon>
              Back
            </button>
          </form>

          <!-- STEP 6: PLAN SELECTION -->
          <div *ngIf="currentStep === 6" class="step-form">
            <!-- Regular Plan Selection -->
            <div *ngIf="!marketplaceToken">
              <p class="step-description">Select the plan that's right for you</p>

              <div class="plans-grid" *ngIf="availablePlans.length > 0">
                <div *ngFor="let plan of availablePlans" 
                     class="plan-card"
                     [class.selected]="selectedPlanKey === plan.planKey"
                     (click)="selectedPlanKey = plan.planKey">
                  <div class="plan-header">
                    <h3>{{ plan.displayName }}</h3>
                    <div class="plan-price">
                      <span class="currency">$</span>
                      <span class="amount">{{ plan.price }}</span>
                      <span class="period">/mo</span>
                    </div>
                  </div>
                  <div class="plan-features">
                    <div class="feature" *ngFor="let feature of plan.features?.split(',')">
                      <mat-icon svgIcon="check_circle" class="feature-icon"></mat-icon>
                      <span>{{ feature.trim() }}</span>
                    </div>
                  </div>
                  <button type="button"
                          mat-raised-button
                          [color]="selectedPlanKey === plan.planKey ? 'primary' : ''"
                          [class.selected-button]="selectedPlanKey === plan.planKey">
                    {{ selectedPlanKey === plan.planKey ? 'Selected' : 'Select Plan' }}
                  </button>
                </div>
              </div>

              <button type="button" 
                      mat-raised-button 
                      color="primary" 
                      class="continue-button"
                      (click)="submitPlan()"
                      [disabled]="!selectedPlanKey || isLoading">
                Subscribe
              </button>
            </div>

            <!-- Marketplace Subscription Info -->
            <div *ngIf="marketplaceToken" class="marketplace-info">
              <div class="flex justify-center" style="margin-bottom: 24px;">
                <div style="width: 80px; height: 80px; border-radius: 50%; background: linear-gradient(135deg, var(--success-green) 0%, #00a86b 100%); display: flex; align-items: center; justify-content: center; box-shadow: 0 4px 16px rgba(76, 175, 80, 0.3);">
                  <mat-icon svgIcon="store" style="color: white; font-size: 40px !important; height: 40px !important; width: 40px !important;"></mat-icon>
                </div>
              </div>
              
              <p class="step-description">
                Your subscription is linked to Azure Marketplace. We'll activate your plan now.
              </p>
              
              <div class="marketplace-benefits">
                <div class="benefit-item">
                  <mat-icon svgIcon="check_circle" style="color: var(--success-green);"></mat-icon>
                  <span>Consolidated billing through Azure</span>
                </div>
                <div class="benefit-item">
                  <mat-icon svgIcon="check_circle" style="color: var(--success-green);"></mat-icon>
                  <span>Enterprise-grade security</span>
                </div>
                <div class="benefit-item">
                  <mat-icon svgIcon="check_circle" style="color: var(--success-green);"></mat-icon>
                  <span>Seamless integration</span>
                </div>
              </div>

              <button type="button" 
                      mat-raised-button 
                      color="primary" 
                      class="continue-button"
                      (click)="submitPlan()"
                      [disabled]="isLoading">
                Complete Setup
              </button>
            </div>

            <button type="button" 
                    mat-stroked-button 
                    class="back-button"
                    (click)="goBack()"
                    [disabled]="isLoading">
              <mat-icon svgIcon="arrow_back"></mat-icon>
              Back
            </button>
          </div>

          <!-- STEP 7: COMPLETION -->
          <div *ngIf="currentStep === 7" class="completion-step">
            <div class="completion-icon">
              <mat-icon svgIcon="check_circle" class="success-icon"></mat-icon>
            </div>
            
            <h2>You're All Set!</h2>
            <p class="completion-message">
              Your account has been created successfully. Redirecting you to your dashboard...
            </p>

            <div class="completion-spinner">
              <mat-spinner diameter="40"></mat-spinner>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>

